module.exports = __webpack_public_path__ + "img/disable-step-2.68b4a86a.svg";